import type { Epic } from 'Flux/index.js'
import { serverIsNotAvailable } from 'Framework/Epic/ServerNotAvailable.js'
import { asyncScheduler, scheduled } from 'rxjs'
import { catchError, filter, mergeMap, retryWhen } from 'rxjs/operators'
import { UnauthorizedError } from 'Framework/Error/UnauthorizedError.js'
import { authenticationSlice } from 'Flux/Slice/Authentication/AuthenticationSlice.js'
import { Environment } from 'environment.js'

export const loginEpic: Epic = (action$, _, { AuthenticationRepository, [authenticationSlice.name]: authentication }) =>
  action$.pipe(
    filter(authentication.loginRequest.match),
    mergeMap(() =>
      AuthenticationRepository.retrieveMe().pipe(
        mergeMap((response) => {
          if (response instanceof Error) {
            throw response
          }
          if (!response.email) {
            return scheduled(
              [
                authentication.loginFailure({
                  error: new UnauthorizedError('common:error:unauthorized:textLogin'),
                  reason: 'invalid_session'
                })
              ],
              asyncScheduler
            )
          }
          return scheduled([authentication.loginSuccess({ user: response })], asyncScheduler)
        }),
        retryWhen(serverIsNotAvailable()),
        catchError((error) => {
          // No usable session: this is the normal cold-start path, so we hand the visitor to
          // Keycloak. Tagged `unauthenticated` so telemetry records a redirect, not a failure.
          window.location.href = `${Environment.API_URL}/oauth/login/keycloak`
          return scheduled([authentication.loginFailure({ error, reason: 'unauthenticated' })], asyncScheduler)
        })
      )
    )
  )
